// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.history .menu-details {
  font-weight: bold;
}
.history .menu-details.bud-req {
  padding-bottom: 5px;
  border-bottom: 2px solid #0078dc;
}
.history .details {
  color: #adadad !important;
  cursor: pointer;
}
.history .details:hover {
  color: #0078dc !important;
}
.history.budget-request .card-header .history-section-title {
  padding-left: 20px;
}
.history .history-card-header .btn-export-history {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0.4rem 20px 0.4rem 0;
  text-align: center;
}
.history .box {
  width: 16px;
  height: 15px;
  display: inline-block;
  top: 2px;
  border-radius: 6px;
  margin-right: 5px;
  position: relative;
}
.history h5 span {
  color: #212529;
}
.history .section-first .multiselect {
  padding-bottom: 15px;
  border-bottom: 1px solid #adadad;
  width: 93%;
}
.history .multiselect--disabled {
  background: none;
  opacity: 1;
}
.history .multiselect--disabled .multiselect__select {
  display: none;
}
.history .mtp-color {
  color: #0078dc;
}
.history .show-elements {
  display: inline-block;
  padding-left: 10px;
}
.history .accordion-history {
  background-color: #fff;
}
.history table {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  display: block;
}
.history .table th {
  border-bottom: 1px solid #dee2e6;
}
.history .table tr:first-child td:first-child {
  border-top: 1px solid transparent;
}
.history .table tr:first-child td:nth-child(2) {
  border-top: 1px solid transparent;
}
.history .table th:last-child {
  border-right: none;
}
.history .table td:last-child {
  border-right: none;
}
.history .table th:first-child {
  width: 5%;
}
.history .table th:nth-child(2) {
  width: 20%;
}
.history .table th:nth-child(3) {
  width: 10%;
}
.history .table th:nth-child(4) {
  width: 15%;
}
.history .table th:nth-child(5) {
  width: 46%;
  border-right: 0;
}
.history .table td:nth-child(5) {
  border-right: 0;
}
.history .table th .btn, .history .table td .btn {
  color: #0078dc;
}
.history .table .btn {
  cursor: pointer;
}
.history .table .btn .plus-icon {
  display: none;
}
.history .table .btn.collapsed .plus-icon {
  display: block;
}
.history .table .btn .minus-icon {
  display: block;
}
.history .table .btn.collapsed .minus-icon {
  display: none;
}
.history .table .btn .fa-icon {
  max-width: none;
  max-height: none;
}
.history .table th,
.history .table td {
  border-top: none;
  border-right: 1px solid #d4d4d4;
  white-space: nowrap;
  background-color: #fff;
  text-align: left;
  padding: 15px;
}
.history .table {
  background-color: #fff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
}
.history tr:nth-child(even) td {
  background-color: #f9f9f9;
}
.history .card-body {
  padding: 35px 0px;
  padding-bottom: 15px;
  padding-top: 0;
}
.history .card-body tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}
.history .arrow {
  cursor: pointer;
  position: relative;
  top: -0.5px;
}
.history .number {
  padding: 0 5px;
  font-weight: bold;
  cursor: pointer;
}
.history .active {
  color: #0078dc;
}
@media (max-width: 575px) {
.history .accordion-history .show-elements {
    display: block;
    padding-left: 0;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
